module.exports = __webpack_public_path__ + "static/dj-paulette-2d565009cc9c3fee058a403abea6d09c.jpg";